<div class="modal-header"><h2 class="modal-title">Bulk Edit ACH Transactions</h2></div>
<div class="modal-body">
    <dx-form *ngIf="achTransaction" [formData]="achTransaction">
        <dxi-item itemType="group">
            <dxi-item dataField="bankConfirmationNumber" [label]="{ text: 'Bank Confirmation #' }"> </dxi-item>
            <dxi-item dataField="transferInitiated" editorType="dxDateBox" [label]="{ text: 'Transfer Initiated' }"> </dxi-item>
        </dxi-item>
    </dx-form>
</div>

<div class="modal-footer">
    <button class="btn btn-success" (click)="save()">Save</button>
    <button class="btn btn-default" (click)="close()">Cancel</button>
</div>
